interface LinkIconProps {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
}

const LinkIcon = ({
    color = 'black',
    width = 16,
    height = 16,
    className
}: LinkIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        className={className}
    >
        <path
            d="M14 2H9.5M14 2V6.5M14 2L8.5 7.5M6.26667 2C4.77333 2 4.02667 2 3.456 2.29067C2.95426 2.54633 2.54633 2.95426 2.29067 3.456C2 4.02667 2 4.77333 2 6.26667V9.73333C2 11.2267 2 11.9733 2.29067 12.544C2.54633 13.0457 2.95426 13.4537 3.456 13.7093C4.02667 14 4.77333 14 6.26667 14H9.73333C11.2267 14 11.9733 14 12.544 13.7093C13.0457 13.4537 13.4537 13.0457 13.7093 12.544C14 11.9733 14 11.2267 14 9.73333V9"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default LinkIcon;

